import { Chip, ChipProps } from "@mui/material";
import dayjs from "dayjs";
import { FC } from "react";
import {
  DagsterRunSummary,
  isInFlightStatus,
} from "../dataHooks/tradeMatchingQueries";

type Props = {
  run: DagsterRunSummary | null;
};

const statusColor = (status: string): ChipProps["color"] => {
  if (isInFlightStatus(status)) {
    return "info";
  }
  if (status === "SUCCESS") {
    return "success";
  }
  if (status === "FAILURE") {
    return "error";
  }
  if (status === "CANCELED" || status === "CANCELING") {
    return "default";
  }
  return "default";
};

const statusLabel = (run: DagsterRunSummary): string => {
  if (isInFlightStatus(run.status)) {
    return "Processing…";
  }
  if (run.status === "SUCCESS") {
    const when = run.endTime ?? run.startTime;
    return when
      ? `Processed ${dayjs(when).format("DD/MM HH:mm")}`
      : "Processed";
  }
  if (run.status === "FAILURE") {
    return "Failed";
  }
  if (run.status === "CANCELED") {
    return "Canceled";
  }
  return run.status;
};

export const StatusChip: FC<Props> = ({ run }) => {
  if (!run) {
    return <Chip size="small" label="Not processed" variant="outlined" />;
  }

  const chip = (
    <Chip
      size="small"
      label={statusLabel(run)}
      color={statusColor(run.status)}
      clickable={!!run.runUrl}
    />
  );

  if (run.runUrl) {
    return (
      <a
        href={run.runUrl}
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none" }}
      >
        {chip}
      </a>
    );
  }

  return chip;
};
